import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { openModal } from "risa-oasis-ui_v2";
import ApiResponseViewerModal from "../../components/modals/apiResponseViewerModal/apiResponseViewerModal";
import DocViewerModal from "../../components/modals/docViewerModal/docViewerModal";
import DocViewerWithSideNavigation from "../../components/modals/docViewerWithSideNavigation/docViewerWithSideNavigation";
import ImageviewerModal from "../../components/modals/imageViewerModal/imageviewerModal";
import { ModalId } from "../../enums/modalId";
import { closeModal } from "../../redux/slice/modalSlice";
import { AppDispatch, RootState } from "../../redux/store/store";
import BackArrowBlue from "../../svg/back-arrow-blue";
import ViewAllEventsTable from "./components/viewAllEventsTable";

const ViewAllEventsLayout = () => {
  const viewAllAuditTrailTableRef = useRef<HTMLDivElement>(null);
  const { openedModalId } = useSelector((state: RootState) => state.modal);
  const dispatch = useDispatch<AppDispatch>();
  const { metaData } = useSelector((state: RootState) => state.modal);
  const navigate = useNavigate();

  useEffect(() => {
    if (openedModalId === ModalId.API_RESPONSE_VIEWER_MODAL) {
      openModal(ModalId.API_RESPONSE_VIEWER_MODAL);
    }
    if (openedModalId === ModalId.IMAGE_VIEWER_MODAL) {
      openModal(ModalId.IMAGE_VIEWER_MODAL);
    }
    if (openedModalId === ModalId.DOC_VIEWER_MODAL) {
      openModal(ModalId.DOC_VIEWER_MODAL);
    }
    if (openedModalId === ModalId.DOC_VIEWER_WITH_SIDE_NAVIGATION) {
      openModal(ModalId.DOC_VIEWER_WITH_SIDE_NAVIGATION);
    }
  }, [openedModalId]);

  return (
    <div className="single-order-for-external--layout">
      <div
        className="single-order-for-external--header hover:cursor-pointer"
        onClick={() => navigate(-1)}
      >
        <BackArrowBlue />
        Go Back
      </div>
      <div className="single-order-for-external--content">
        <ViewAllEventsTable
          viewAllAuditTrailTableRef={viewAllAuditTrailTableRef}
        />
      </div>
      <>
        {openedModalId === ModalId.API_RESPONSE_VIEWER_MODAL && (
          <ApiResponseViewerModal onClose={() => dispatch(closeModal())} />
        )}
        {openedModalId === ModalId.IMAGE_VIEWER_MODAL && (
          <ImageviewerModal
            onClose={() => dispatch(closeModal())}
            fileUrls={[]}
            filePaths={metaData?.filePaths ?? []}
          />
        )}
        {openedModalId === ModalId.DOC_VIEWER_MODAL && (
          <DocViewerModal
            onClose={() => dispatch(closeModal())}
            type="clinical_attachment"
          />
        )}
        {openedModalId === ModalId.DOC_VIEWER_WITH_SIDE_NAVIGATION && (
          <DocViewerWithSideNavigation items={metaData?.items ?? []} />
        )}
      </>
    </div>
  );
};

export default ViewAllEventsLayout;
